import { el } from 'redom';

import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import 'range-slider-input/dist/style.css';

class Track {

  constructor(playerTracks) {

    this.track = null;
    this.index = -1;
    this.playerTracks = playerTracks;
    this.nameView = el('span.video-builder-track-name', {
      onclick: this.handleNameClick.bind(this)
    });
    this.slider = el('.video-builder-track-slider');

    this.sliderInstance = noUiSlider.create(this.slider, {
      start: [0, 60],
      range: {
        min: 0,
        max: 60
      },
      connect: true,
      step: 1,
      onChange: (values, userInteraction) => userInteraction && this.handleTrackChange(values)
    });
    this.slider.noUiSlider.on('change', (values, handle) => this.handleTrackChange(values));

    this.el = el('.video-builder-track', [
      this.nameView,
      this.slider
    ]);

  }

  handleNameClick() {

    this.playerTracks.videoBuilder.handleNameClick(this.track);

  }

  onunmount() {
    this.slider.noUiSlider.destroy();
  }

  handleTrackChange(values) {

    const track = { ...this.track };
    track.start = +values[0];
    track.duration = +values[1] - track.start;
    this.track = track;
    this.playerTracks.videoBuilder.playerProperties.tracks[this.index] = track;
    this.playerTracks.videoBuilder.updateProperties({ player: structuredClone(this.playerTracks.videoBuilder.playerProperties) });

  }

  update(track, index) {

    this.track = { ...track };
    this.index = index;
    this.nameView.textContent = this.track.name;

    // this.slider.noUiSlider.set([this.track.start, this.track.start + this.track.duration]);
    this.slider.noUiSlider.updateOptions({
      start: [this.track.start, this.track.start + this.track.duration],
      range: {
        min: 0,
        max: this.playerTracks.videoBuilder.playerProperties.durationInSeconds
      }
    }, false);

  }

}

export default Track;